import { PdfGen } from '../pdf/pdf';
import { OptsImage } from './optsImage';

export const ILayoutImageSymbol = Symbol('LayoutImage');

export interface ILayoutImageGen {
  generate(pdf: PdfGen, opts: OptsImage): Promise<void>;
}
